var winWidth = $(window).width(),
    winHeight = $(window).height();

$(function() {
    $('body').on('click','.nav-icon',function(){
        menuOpen();
    }).on('click', '.js-sideMenu:not(.is--active)', function() {
        sideMenuOpen();
    }).on('click', '.js-sideMenu.is--active', function() {
        sideMenuClose();
    }).on('click', '.js-sideMenu-close', function() {
        sideMenuClose();
    }).on('click touchstart', '.js-defaultOverlay', function() {
        sideMenuClose();
    });
});

$(window).on('load', function() {
});

$(window).on('resize orientationchange', function() {
    winWidth = $(window).width(),
    winHeight = $(window).height();
});

$(document).keyup(function(e) {
    if (e.keyCode == 27) {
    }
});

function menuOpen() {
    $(this).toggleClass('open');
};

function sideMenuOpen() {
    $('.js-sideMenu').addClass("is--active");
    $('.c-side-nav').not(".is--open").addClass('is--open');
    $('body').addClass("is--menu");
}

function sideMenuClose() {
    $('.js-sideMenu').removeClass("is--active");
    $('.c-side-nav.is--open').removeClass("is--open");
    $('body').removeClass("is--menu");
}